import { post, postData } from '../../util/Api';
import { Invoice } from '../InvoiceModel';

export interface DailyReportsExternalMember {
  id: number;
  createdAt: Date | null;
  updatedAt: Date | null;
  user_id: number;
  name: string;
  company_id: number;
  email: string;
  is_send: number;
}

// DailyReportMember class implementing the interface
export class DailyReportsExternalMemberModel {
  static set(data: any): DailyReportsExternalMember {
    const d: DailyReportsExternalMember = {
      id: data.id,
      createdAt: data.createdAt,
      updatedAt: data.updatedAt,
      user_id: data.user_id,
      name: data.name,
      company_id: data.company_id,
      email: data.email,
      is_send: data.is_send,
    };

    return d;
  }

  /**
   * 保存する
   * @param params
   */
  static async save(params: { members: DailyReportsExternalMember[] }): Promise<void> {
    const uri = `/daily_reports/external-members/save`;
    let response = await postData(uri, params);
  }

  /**
   * メンバーを取得する
   * @param params
   * @returns
   */
  static async fetchAll(): Promise<DailyReportsExternalMember[]> {
    const uri = `/daily_reports/external-members/all`;

    const response = await postData(uri, this);

    if (response.status !== 200) {
      throw new Error();
    }
    const responseData = response.data;
    const users = Array.isArray(responseData)
      ? responseData.map((data: any) => this.set(data))
      : [this.set(responseData.data)];

    return users;
  }

  /**
   * 空データを作成する
   * @returns
   */
  static empty(): DailyReportsExternalMember {
    return {
      id: 0,
      createdAt: null,
      updatedAt: null,
      user_id: 0,
      name: '',
      company_id: 0,
      email: '',
      is_send: 1,
    };
  }
}
